import React from 'react';
import Wordle from './Game';
import { WordleProvider } from './WordleContext';

const WordleHookProvider: React.FC = () => {
  return (
    <WordleProvider>
      <Wordle />
    </WordleProvider>
  );
};

export default WordleHookProvider;